import React, { useState, useEffect, useMemo } from "react";
import { Dropdown, Header } from "semantic-ui-react";
import { GetCashFlowAreasData } from "../../../../../graphql/cashflowAreas";
import "./style.scss";
import { GetHeaders } from "../../../../../utils/getHeaders";
import { GetFlowStructure } from "../../../../../graphql/cashflow";
import { FlowLVL } from "../../../../../utils/flujoCaja";

export const SelectorCashflow = ({
  style = {},
  onChange = () => { },
  onBlur = () => { },
  id = "defaultEERRArea",
  name = "defaultEERRArea",
  className = "",
  placeholder = "Área de EERR",
  defaultValue = "",
  multiple = false,
  clearable = true,
  value = "",
  companyId = "",
  controlled = true,
  showWithoutArea = false
}) => {

  const defaultDropdown = <Dropdown
    selectOnBlur={false}
    noResultsMessage="No se encontraron áreas"
  />;

  const [search, setSearch] = useState("");

  const getFlowStructure = GetFlowStructure({ companyId });

  const flowStructure = getFlowStructure.data?.getFlowStructure || [];

  useEffect(() => {
    if (companyId) getFlowStructure.reexecuteFlow({ companyId })
  }, [companyId]);

  const list = useMemo(() => {
    const [flow] = flowStructure;

    if (!flow) return [];

    let dropdownItems = [];

    const IncomeCategories = flow.report[FlowLVL.INCOME];
    const ExpenseCategories = flow.report[FlowLVL.EXPENSE];

    const categories = [...IncomeCategories, ...ExpenseCategories];

    dropdownItems = categories.reduce((acc, categoryRow) => {
      const fields = categoryRow.fields.map((field, index) => {
        const fieldObject = {
          id: `${field.cashflowAreaId}-${index}`,
          key: `${field.cashflowAreaId}-${index}`,
          name: field.cashflowAreaId,
          value: field.cashflowAreaId,
          text: field.label,
          content: field.label,
          disabled: false,
        }
        return (fieldObject)
      })

      const headerTag = {
        name: categoryRow.cashflowCategoryId,
        text: categoryRow.label,
        disabled: true,
        className: "headerDropdownPepper",
        content: (
          <Header
            style={{
              fontSize: "1em",
              color: "#0099ff",
              fontWeight: 700,
              textTransform: "uppercase",
            }}
            content={categoryRow.label}
            size="small"
          />
        ),
      }
      acc = [...acc, headerTag]
      acc = [...acc, ...fields]
      return acc
    }, []);


    const withoutAreaElements = [
      {
        name: "Sin clasificar",
        text: "SIN CLASIFICAR",
        disabled: true,
        className: "headerDropdownPepper",
        content: (
          <Header
            style={{
              fontSize: "1em",
              color: "#0099ff",
              fontWeight: 700,
              textTransform: "uppercase",
            }}
            content={"SIN CLASIFICAR"}
            size="small"
          />
        ),
      },
      {
        id: "sinclasificar",
        key: "sinclasificar",
        name: "Sin clasificar",
        value: "sinclasificar",
        text: "Sin clasificar",
        content: "Sin clasificar",
        disabled: false,
      }
    ];

    return [
      ...(
        showWithoutArea
          ? withoutAreaElements
          : []
      ),
      ...dropdownItems
    ];
  }, [companyId, getFlowStructure.fetching, getFlowStructure.data?.getFlowStructure]);

  if (!companyId) return defaultDropdown

  const searchingFunction = (_, s) => {
    setSearch(s?.searchQuery)
  }

  if (controlled) { //  CONTROLADO

    const selected = list.find(f => f.value === value);
    const text = !value ? null : selected?.text;

    return (
      <Dropdown
        selectOnBlur={false}
        text={text}
        placeholder={placeholder}
        multiple={multiple}
        value={value}
        onSearchChange={searchingFunction}
        search
        selection
        fluid
        noResultsMessage="No se encontraron resultados."
      >
        <Dropdown.Menu className="dropdownCashflow">
          <Dropdown.Menu scrolling onBlur={onBlur} noResultsMessage="El área no existe">
            {list.filter((f) => f?.text?.toLowerCase()?.includes(search.toLowerCase())).map((option) => (
              <Dropdown.Item {...option} onClick={onChange} />
            ))}
          </Dropdown.Menu>
        </Dropdown.Menu>
      </Dropdown>
    )

  } else { //NO CONTROLADO
    //* Revisar en caso de que no funcione, es lo mismo que el selectorEERR pero no se le cambió nada
    return (
      <Dropdown
        selectOnBlur={false}
        className={className}
        multiple={multiple}
        style={{ ...style }}
        placeholder={placeholder}
        id={id}
        name={name}
        options={list}
        onBlur={onBlur}
        clearable={clearable}
        onChange={onChange}
        defaultValue={defaultValue}
        selection
        search
        fluid
        noResultsMessage="El área no existe"
      />
    );
  }
};
